export const centerImages = [
  {
    panelName:'EP05场景图-储能',
    panelId: 180003,
    src: "/static/images/boss/panelPic/cn-ep05.png",
    class:"type1"
  },
  {
    panelName:'EP06场景图-储能',
    panelId: 180004,
    src: "/static/images/boss/panelPic/cn-ep06.png",
    class:"type1"
  },
  {
    panelName:'单元柜场景图-储能',
    panelId: 180005,
    src: "/static/images/boss/panelPic/cn-danyuangui.png",
    class:"type1"
  },
  {
    panelName:'集装箱场景图-储能',
    panelId: 180006,
    src: "/static/images/boss/panelPic/cn-jizhuangxiang.png",
    class:"type1"
  },
  {
    panelName:'梯次储能场景图-储能',
    panelId: 180007,
    src: "/static/images/boss/panelPic/cn-danyuangui.png",
    class:"type1"
  },
  // 光储
  {
    panelName:'EP05场景图-光储',
    panelId: 180008,
    src: "/static/images/boss/panelPic/gc-ep05.png",
    class:"type2"
  },
  {
    panelName:'EP06场景图-光储',
    panelId: 180009,
    src: "/static/images/boss/panelPic/gc-ep06.png",
    class:"type2"
  },
  {
    panelName:'单元柜场景图-光储',
    panelId: 180010,
    src: "/static/images/boss/panelPic/gc-danyuangui.png",
    class:"type2"
  },
  {
    panelName:'集装箱场景图-光储',
    panelId: 180011,
    src: "/static/images/boss/panelPic/gc-jizhuangxiang.png",
    class:"type2"
  },
  {
    panelName:'梯次储能场景图-光储',
    panelId: 180012,
    src: "/static/images/boss/panelPic/gc-danyuangui.png",
    class:"type2"
  },
  // 光储充
  {
    panelName:'EP05场景图-光储充',
    panelId: 180013,
    src: "/static/images/boss/panelPic/gcc-ep05.png",
    class:"type3"
  },
  {
    panelName:'EP06场景图-光储充',
    panelId: 180014,
    src: "/static/images/boss/panelPic/gcc-ep06.png",
    class:"type3"
  },
  {
    panelName:'单元柜场景图-光储充',
    panelId: 180015,
    src: "/static/images/boss/panelPic/gcc-danyuangui.png",
    class:"type3"
  },
  {
    panelName:'集装箱场景图-光储充',
    panelId: 180016,
    src: "/static/images/boss/panelPic/gcc-jizhuangxiang.png",
    class:"type3"
  },
  {
    panelName:'梯次储能场景图-光储充',
    panelId: 180017,
    src: "/static/images/boss/panelPic/gcc-danyuangui.png",
    class:"type3"
  }
]



// WEBPACK FOOTER //
// ./src/utils/centerImages.js